import Swiper from 'swiper/bundle';

class SwiperNearContent {
  constructor({ elm }) {
    const slides = elm.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    const slidesPerView = window.innerWidth >= 1024 ? 3 : 1;
    const loopEnabled = slideCount > slidesPerView;
    this.swiper = new Swiper(elm, {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: loopEnabled,
      centeredSlides: true,
      centerInsufficientSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 750,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
      navigation: {
        nextEl: elm.querySelector('[data-role="near-contents-swiper-nav-next"]'),
        prevEl: elm.querySelector('[data-role="near-contents-swiper-nav-prev"]'),
      },
      pagination: {
        el: '[data-role="near-contents-swiper-pagination"]',
        clickable: true,
      },
      on: {
        init: function () {
          const prevBtn = elm.querySelector('[data-role="near-contents-swiper-nav-prev"]');
          const nextBtn = elm.querySelector('[data-role="near-contents-swiper-nav-next"]');

          if (!loopEnabled) {
            prevBtn.classList.add('is-disabled');
            nextBtn.classList.add('is-disabled');
          } else {
            prevBtn.classList.remove('is-disabled');
            nextBtn.classList.remove('is-disabled');
          }
        },
      },
    });
  }
}

export default SwiperNearContent;
